<script>
import { mapActions } from "vuex";

import Purchases from "../Purchases.vue";

import BaseSupplierDialogSelector from "@/components/shared/BaseDialogSelectors/BaseSupplierDialogSelector.vue";
import BaseLocationDialogSelector from "@/components/shared/BaseDialogSelectors/BaseLocationDialogSelector.vue";
import BaseUserDialogSelector from "@/components/shared/BaseDialogSelectors/BaseUserDialogSelector.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

export default {
  extends: Purchases,
  components: {
    BaseSupplierDialogSelector,
    BaseLocationDialogSelector,
    BaseUserDialogSelector,
    DateRangePicker,
  },
  page: {
    title: "Purchase Orders",
  },
  data() {
    return {
      modelName: { singular: "Purchase Order", plural: "Purchase Orders", code: "PO" },
    };
  },
  methods: {
    ...mapActions("purchases", ["fetchPurchaseOrders", "archivePurchaseOrder"]),
    ...mapActions("application", ["setIsTableLoading"]),

    async archive(id, value) {
      try {
        await this.archivePurchaseOrder({
          id: id,
          archive: value,
        });
        this.query();
      } catch {}
    },

    create() {
      this.$router.push({
        name: "Edit Purchase Order",
      });
    },

    edit(id) {
      this.$router.push({
        name: "Edit Purchase Order",
        params: {
          id: id,
        },
      });
    },

    query() {
      this.setIsTableLoading(true);
      this.fetchPurchaseOrders({
        organisation: this.getCurrentOrganisation.id,
        ...this.query_params,
      }).then((res) => {
        this.purchases = res.data;
      }).catch((error) => {
      }).finally(() => {
        this.setIsTableLoading(false);
      });
    },
  },
  mounted() {
    this.query();
  },
};
</script>

<template>
  <div>
    <PageHeader
      :modelName="modelName"
      @create="create"
      v-model="query_params.search"
    >
      <template v-slot:filters>
        <base-toggle-button-group id="archived" label="Void" variant="primary" v-model="query_params.archived" :options="void_options"/>
        <DateRangePicker :start.sync="query_params.date_start" :end.sync="query_params.date_end"/>
        <base-input label="Delivery Date" type="date" v-model="query_params.delivery_date" />
        <BaseLocationDialogSelector v-model="query_params.location" disableAdd />
        <base-purchase-selector label_name="Parent" v-model="query_params.parent" />
        <base-input type="multiselect" id="payment_status" label="Payment Status" v-model="query_params.payment_status" :options="['Paid', 'Unpaid']" />
        <base-input type="multiselect" id="status_filter" label="Status" v-model="query_params.status" :options="['Draft', 'Confirmed']" />
        <BaseSupplierDialogSelector v-model="query_params.supplier" disableAdd />
        <BaseUserDialogSelector label="Purchase Person" v-model="query_params.purchase_person" />
        <BaseUserDialogSelector label="Created By" v-model="query_params.created_by" />
        <BaseUserDialogSelector label="Edited By" v-model="query_params.edited_by" />
      </template>
    </PageHeader>

    <base-card>
      <base-table
        ref="table"
        :data_="purchases"
        :fields="fields"
        :modelName="modelName"
        @archive="archive"
        @edit="edit"
        @page_change="query_params.page = $event"
        @page_size_change="query_params.page_size = $event"
        @ordering_change="query_params.ordering = $event"
      />
    </base-card>
  </div>
</template>
